import jfetch from '@jontetz/jfetch';

export function getCurrentContact() {
    return jfetch.get('/api/contact/getcurrentcontact');
}